import type { ComputedRef, InjectionKey } from 'vue'
import type { MatrixSession } from './useMatrixSession'
import type { MatrixOverlay } from './useMatrixOverlay'
import type { useGnkRate } from '../composables/useGnkRate'
import type { UseActivationPending } from '../composables/useActivationPending'
import type { UseLevelCelebrated } from '../composables/useLevelCelebrated'
import type { MatrixRealtimeController } from '../composables/useMatrixRealtime'

/** Host services for the original matrix UI; scoped to a mounted subtree. */
export interface MatrixEnvironment {
  session: MatrixSession
  overlay: MatrixOverlay
  rate: ReturnType<typeof useGnkRate>
  activationPending: UseActivationPending
  levelCelebrated: UseLevelCelebrated
  realtime: MatrixRealtimeController
  referralLink: ComputedRef<string>
}

export const matrixEnvironmentKey: InjectionKey<MatrixEnvironment> =
  Symbol('matrix-environment')
